<template>
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g class="fill-current">
                <polygon id="Path-126" points="0 11 2 9 7 14 18 3 20 5 7 18"></polygon>
            </g>
        </g>
    </svg>
</template>
